module.exports = __webpack_public_path__ + "img/medal3.64af464c.png";